/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'fm-close-icon-button',
  templateUrl: './close-icon-button.component.html',
  styleUrls: ['./close-icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CloseIconButtonComponent {
  a7sId = input('');
  closeClick = output<void>();

  onClick(): void {
    this.closeClick.emit();
  }
}
